<template>
    <div>
        <div class="mb-3 d-flex">
            <v-divider class="border-opacity-100" vertical :thickness="4" :color="$system.systemSettings.knowledge_base_color"></v-divider>
            <h4 class="mb-1 ms-2">به پایگاه دانش {{ $system.systemSettings.system_title }} خوش آمدید</h4>
        </div>
        <div class="text-meta mb-3" v-if="$system.systemSettings.knowledge_base_message" v-sanitize="$system.systemSettings.knowledge_base_message"></div>
        <div class="my-6 d-flex" v-if="articleList && articleList.length">
            <v-divider class="border-opacity-100" vertical :thickness="4" :color="this.$system.systemSettings.knowledge_base_color"></v-divider>
            <h4 class="mb-1 ms-2">{{$system.systemSettings.knowledge_base_default_articles_sort == 'most_viewed' ? 'پربازدیدترین مطالب' : $system.systemSettings.knowledge_base_default_articles_sort == 'most_liked' ? 'محبوب ترین مطالب' : 'آخرین مطالب'}}</h4>
        </div>
        <div class="d-flex align-center mb-3 pa-4 border cursor-pointer rounded" v-for="item in articleList" @click="$router.push({ path: `/kb/articles/${item.id}/${item.slug}` }); searchDialog = false;">
            <v-icon size="21" class="me-2" color="grey-darken-1">icon-filekb</v-icon>
            <p class="text-meta text-grey-darken-3 flex-grow-1">{{ item.name }}</p>
            <v-divider class="mx-2 border-opacity-50" vertical></v-divider>
            <v-icon v-if="item.read_time" class="me-2" color="grey-darken-1" size="16">icon-timekb</v-icon>
            <p v-if="item.read_time" class="text-small text-grey-darken-2">{{ item.read_time }} دقیقه</p>
        </div>
    </div>
</template>
<script>
export default {
    layout:"kb",
    auth: false,
    validate(context) {
        return context.system.systemSettings.kb_core && context.system.systemSettings.knowledge_base_status;
    },
    data() {
        return {
            articleList:[],
        }
    },
    mounted() {
        this.$nextTick(async ()=>{
            this.$loading.start();
            if (this.$system.systemSettings.knowledge_base_default_articles_sort)
                await this.$kbArticleList({order: this.$system.systemSettings.knowledge_base_default_articles_sort}).then(res => {
                    if(res && res.data.length && res.status == "OK")
                        this.articleList = [...res.data];
                })
            this.$loading.finish();
        })
    },
}
</script>
